import React from 'react';
import { useTranslation } from 'react-i18next';

import { Form, CheckboxLabel } from '@weezevent/nacre';

import { InfoTextTooltip } from '../../../../../attendee/detail/components/infotext-tooltip/infoTextTooltip';

import Style from '../moderationModal.module.css';

export const Validations = ({ transitionValidations, validationsInputs, setValidationsInputs }) => {
    const { t } = useTranslation();

    const handleChange = React.useCallback(
        (index, value) => {
            let values = [...validationsInputs];
            values[index].value = value;
            setValidationsInputs(values);
        },
        [validationsInputs]
    );

    return (
        <>
            {transitionValidations?.map((tr, index) => (
                <div key={index} className={Style['moderation-modal-validations']}>
                    <CheckboxLabel
                        label={
                            <InfoTextTooltip
                                title={<Form.Label optionalText={!tr.checkbox_mandatory && t('ticket.common.labelOptionalParenthesis')}>{tr.checkbox_label}</Form.Label>}
                                subtitle={tr.checkbox_description}
                                tooltip={false}
                            />
                        }
                        checked={validationsInputs[index]?.value || false}
                        onChange={({ target: { checked } }) => handleChange(index, checked)}
                    />
                </div>
            ))}
        </>
    );
};
